
import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import AdminNav from '@/components/admin/AdminNav';
import { Card, CardContent } from '@/components/ui/card';

interface ReferralUsersLoadingProps {
  onLogout?: () => void;
}

const ReferralUsersLoading: React.FC<ReferralUsersLoadingProps> = ({ onLogout }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header isLoggedIn={true} isAdmin={true} onLogout={onLogout} />
      
      <main className="flex-grow py-8 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-8">
            <h1 className="text-2xl font-bold text-gray-900">Referral Users Report</h1>
            <p className="text-gray-600">View and search all users who signed up through referrals</p>
          </div>
          
          <AdminNav />
          
          <Card className="mb-8">
            <CardContent className="py-10">
              <div className="flex justify-center items-center">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
              </div>
            </CardContent>
          </Card>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default ReferralUsersLoading;
